import SubtradeChannel from './SubtradeChannel'
import TradeGroup from './TradeGroup'
import TradeName from './TradeName'
import ManagedBy from './ManagedBy'
import GlobalCustomer from './GlobalCustomer'
export class KeyAccount {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
    PrimaryFranchiseGroup?: string;
    DefaultSubtradeChannelID?: number;
    DefaultTradeGroupID?: number;
    DefaultTradeNameID?: number;
    OverarchingProgramsGroup?: string;
    SecondaryFranchiseAgreementsGroup?: string;
    OnOffPromotionsGroup?: string;
    SubtradeChannel?: SubtradeChannel;
    TradeGroup?: TradeGroup;
    TradeName?: TradeName;
    ManagedByID?: number;
    GlobalCustomerID?: number;
    ManagedBy?: ManagedBy;
    GlobalCustomer?: GlobalCustomer;
    Inactive: boolean;
}

export default KeyAccount;